import React from 'react';
import Modal from '../../../../Presentation/components/ui/Modal';
import {PermissionForm} from '../forms/PermissionForm';
import {Permission, CreatePermissionRequest, UpdatePermissionRequest} from '../../models/permission.model';

interface PermissionModalProps {
  open: boolean;
  onClose: () => void;
  permission?: Permission;
  onSubmit: (permissionData: CreatePermissionRequest | UpdatePermissionRequest) => Promise<void>;
  loading?: boolean;
}

export const PermissionModal: React.FC<PermissionModalProps> = ({
  open,
  onClose,
  permission,
  onSubmit,
  loading = false
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={permission ? 'تعديل الصلاحية' : 'إنشاء صلاحية جديدة'}
      width="max-w-5xl"
    >
      <PermissionForm
        permission={permission}
        onSubmit={onSubmit}
        onCancel={onClose}
        loading={loading}
      />
    </Modal>
  );
};
